
import { useState, useEffect } from 'react'
import { inject, observer } from 'mobx-react';
import { setOptions } from '../../../helpers'
import { Modal, Button, ModalAlert, FormLoading } from '../../../components'
import { PictureService } from "../../../services";
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import { PlusIcon } from '@heroicons/react/outline';
import { isEmpty } from 'lodash'
import ModalPictureForm from './ModalPictureForm';
import { useTranslation } from 'react-i18next'

let firstRender = false
const ModalManagement = inject("pictureStore", "authenStore")(observer((props) => {
  const { t } = useTranslation(['picture', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }


  let { masterOptions, open } = props // STATES
  let { onClosed } = props // ACTIONS
  const [loading, setLoading]: any = useState({ visible: false, tip: 'saving' })
  const [dataSource, setDataSource]: any = useState([])
  const [shakeIsWrong, setShakeIsWrong] = useState(false)
  const [dataEdit, setDataEdit]: any = useState({})
  const [openForm, setOpenForm]: any = useState(false)
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      getPicture()
    }
    else
      firstRender = true
  }, [open, getAccountAuth])

  const getPicture = () => {
    PictureService.getPicture(auth)
      .then((res: any) => {
        let { code, message, result, sys_message } = res
        if (code === 200) {
          setDataSource(result)
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ดึงข้อมูลผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
          setLoading(false)
        }
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ดึงข้อมูลผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const deletePicture = (id) => {
    PictureService.deletePicture(auth, id)
      .then((res: any) => {
        if (res.code === 200) {
          setOptionAlert(setOptions({
            defaultOption: optionAlert,
            show: true,
            title: t('common:delete_success')
          }))
          getPicture()
        }
      })
      .catch((err) => {
        setOptionAlert(setOptions({
          defaultOption: optionAlert,
          show: true,
          type: "danger",
          title: "ผิดพลาด",
          description: { visible: true, content: `${err}` }
        }))
      })
  }

  return (<>
    <Modal
      title={{ text: t('manage_photos') }}
      open={open}
      maskClosable={true}
      shake={shakeIsWrong}
      // width={"w-3/5"}
      onClosed={() => { onClosed() }}
      extra={<Button
        text={t('add_data')}
        icon={<PlusIcon />}
        iconPosition='start'
        onClick={() => setOpenForm(true)}
      />}
      footer={<Button
        text={t('common:btn_close')}
        width="w-20"
        type="white"
        onClick={() => onClosed()}
      />}
    >
      <FormLoading loading={loading.visible} tip={loading.tip}>
        <DataGrid
          dataSource={dataSource}
          keyExpr="id"
          height="calc(60vh)"
          showBorders={true}
          columnAutoWidth={true}
          hoverStateEnabled={true}
        >
          <Scrolling columnRenderingMode="virtual" />
          <Column
            dataField="no"
            caption={t('no')}
            width={50}
            alignment="center"
          />
          <Column dataField="pic_code" caption={t('pic_code')} />
          <Column dataField="pic_type_name" caption={t('pic_type')} />
          <Column dataField="pic_desc" caption={t('pic_desc')} />
          <Column dataField="status_name" caption={t('status')} />
          <Column
            fixed={true}
            caption={t('edit_delete')}
            type="buttons"
            width={90}
            buttons={[
              {
                hint: t('common:close'),
                icon: "fa fa-pencil-square-o",
                visible: true,
                onClick: (e) => {
                  e.cancel = "true"
                  let data = e.row.data
                  setDataEdit(data)
                  setOpenForm(true)
                }
              },
              {
                hint: t('common:delete'),
                icon: "trash",
                visible: true,
                onClick: (e) => {
                  e.cancel = "true"
                  let data = e.row.data

                  setOptionAlert(setOptions({
                    defaultOption: alert,
                    action: {
                      id: data.id,
                      name: 'delete'
                    },
                    show: true,
                    type: "confirm",
                    title: t('common:confirm'),
                    description: {
                      visible: true,
                      content: t('common:confirm_delete_data'),
                    }
                  }))
                }
              }
            ]} />
        </DataGrid>
      </FormLoading>

      <ModalPictureForm
        auth={auth}
        open={openForm}
        data={dataEdit}
        mode={isEmpty(dataEdit) ? "add" : "edit"}
        masterOptions={masterOptions}
        onClosed={(reload) => {
          setOpenForm(false)
          setDataEdit({})
          reload && getPicture()
        }}
      />
    </Modal>

    <ModalAlert
      {...optionAlert}
      onOk={() => {
        let { type, action } = optionAlert
        if (action.name === "delete")
          deletePicture(action.id)
        setOptionAlert({ ...optionAlert, show: false })
      }}
      onCancel={() => {
        setOptionAlert({ ...optionAlert, show: false })
      }}
    />
  </>
  )
}))

export default ModalManagement